import React from "react";
import {ApprovalMaterialRequestApp} from "../../Functionality/ApprovalMaterialRequestApp";
import HeadTittle from "../../../../../components/HeadTittle";
import {CheckOutlineIcon, DeniedOutlineIcon} from "../../../../../components/buttons/IconButtons";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import MaterialApprovalCard from "./MaterialApprovalCard";
import CancelModal from "../../../Dining/Schedules/Modal/CancelModal";
import {getInfoParagraphByStatus} from "../../../ApprovalTracker/Model/Model";
import DivContainerBody from "../../../../../components/DivContainerBody";
import MaterialApprovalBadge from "./MaterialApprovalBadge";
import {permissionObj} from "../../../../../Helpers/permission";
import routes from "../../../../../Routes/routes";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 */
const ApprovalMaterialRequest = () => {
    const {
        DEV,
        permission,
        navigate,
        resultsToShow,
        setShowApprove,
        setShowDenied,
        setRow,
        styles,
        genericCommentModals,
        t,
        currentStatusConfig,
        handleOnBack,
        showButtonsToApprove,
        handleOnClick
    } = ApprovalMaterialRequestApp()

    if (!DEV &&
        !permission?.includes(permissionObj.WEB_MATERIAL_REQUEST_READ)
    )
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={t('approval_tracker')} onBack={handleOnBack}>
                <div className={"d-flex justify-content-end gap-3 mb-16px"}>
                    { showButtonsToApprove && (DEV || permission?.includes(permissionObj.WEB_MATERIAL_REQUEST_UPDATE)) &&
                    (
                        <>
                            <ButtonAction
                                Icon={CheckOutlineIcon}
                                id='btn_amr_approved_modal'
                                className={'btn-icon-svg-chip-button btn-outlined-success-600 w-40px h-40px minw-40px p-0'}
                                iconProps={'icon'}
                                iconClass={"mr-0"}
                                onClick={() => {
                                    setRow(resultsToShow?.id)
                                    setShowApprove(true);
                                }}
                            />
                            <ButtonAction
                                Icon={DeniedOutlineIcon}
                                id='btn_amr_denied_modal'
                                className={'btn-icon-svg-chip-button btn-outlined-error-600 w-40px h-40px minw-40px p-0'}
                                iconProps={'icon'}
                                iconClass={"mr-0"}
                                onClick={() => {
                                    setRow(resultsToShow?.id)
                                    setShowDenied(true);
                                }}
                            />
                        </>
                    )
                    }
                </div>
            </HeadTittle>
            <DivContainerBody>
                <MaterialApprovalBadge
                    t={t}
                    currentStatusConfig={currentStatusConfig}
                    approvalReason={resultsToShow?.approvalReason}
                    approvalUser={resultsToShow?.approvalUser}
                    approvalDate={resultsToShow?.approvalDate}
                />

                <MaterialApprovalCard
                    data={resultsToShow}
                    styles={styles}
                    t={t}
                />

            </DivContainerBody>

            {genericCommentModals.map(({
                show,
                setter,
                title,
                status,
                requiredComment
            }) => {
                return (
                    <>
                        <CancelModal
                            show={show}
                            onHide={() => setter(false)}
                            onConfirm={(e, comment) => {
                                handleOnClick(comment, status);
                            }}
                            requiredComment={requiredComment}

                            title_modal={title}
                            description={t("are_you_sure_to_proceed")}
                            subDescription={t(getInfoParagraphByStatus(status))}
                        />
                    </>
                );
            })}
        </>
    )
}

export default ApprovalMaterialRequest
